import { render, staticRenderFns } from "./BemerkungAnwesenheiten.vue?vue&type=template&id=4617f72f"
import script from "./BemerkungAnwesenheiten.vue?vue&type=script&lang=ts"
export * from "./BemerkungAnwesenheiten.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports